import { render, staticRenderFns } from "./librarySettings.vue?vue&type=template&id=3b05b14e&scoped=true&"
import script from "./librarySettings.vue?vue&type=script&lang=js&"
export * from "./librarySettings.vue?vue&type=script&lang=js&"
import style0 from "./librarySettings.vue?vue&type=style&index=0&id=3b05b14e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05b14e",
  null
  
)

export default component.exports